import * as _ from 'lodash'
import * as React from 'react'
import Persistence from '../Components/Persistence'

import { Link, Navigate } from 'react-router-dom'
import SDKFactory from '../Components/SDKFactory'
import { T } from '@homeschooling/sdk'

import brandHero from '../Components/brand/hero.png'

import { InputField } from '../Components/Form/InputField'

Persistence.setValues()

interface Form {
  [key: string]: string
}

interface Props { }

interface State {
    user: number,
    form: Form,
    errors: { [key: string]: string }
}

export class Login extends React.Component<Props, State> {
    private sdk = SDKFactory.getUsersSDK()

    public constructor (props: Props) {
        super(props)
    
        this.state = {
          user: 0,
          form: {
            email: '',
            password: ''
          },
          errors: {}
        }
      }

      public inputChanged = (key: string) =>
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
          const { form } = this.state
          form[key] = e.target.value

          this.setState({
            form,
          })
        }   

    public verify = async () => {

        try {

            let errors: any = {}

          let password = this.state.form.password

          if (password.length < 8) errors['password'] = 'Password must be atleast 8 characters'
          if (password.length > 20) errors['password'] = 'Password must be less than 20 characters'

           if (Object.keys(errors).length !== 0) {
              this.setState({ errors: errors })
              return
            }

            const res = await this.sdk
              .verifyUser(
                this.state.form.email,
                this.state.form.password
              )
                    
              let user = res.data
              const hasError: boolean = _.get(user, 'error', false) as boolean
    
              if(!hasError){
                user = user as T.User
                Persistence.setAuth(user)
                this.setState({user: Number(user.id)})
              } else {
                let error = user as T.ErrorMessage
                this.setState({errors: {email: error.error}})
              }
          } catch (reason) {
            console.log('The provided username or password was incorrect.  Please contact support or try again.')
          }  
    }

    public render () {
        const { form} = this.state
        const user = Persistence.getUserId()

        if(user > 0) {
          //alert("I want to go to dashboard")
            return(<Navigate to='/schedule' />)
        }

        return (
          <section className="bg-gray-300 border-y-2">
          <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
              <div className='mb-8 flex flex-col h-250 w-500 items-center justify-cent'>
                <img  src={brandHero} className='w-96 object-cover' alt="Homeschool and Daily Activity Tracker"/>
              </div>
              <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
                  <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                      <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                          Sign in to your account
                      </h1>
                      <form noValidate className="space-y-4 md:space-y-6">
                          <div>
                          <InputField
                            borderColor='default'
                            cb={this.inputChanged('email')}
                            disabled={false}
                            errors={this.state.errors?.email}
                            helperErrors={true}
                            label={'Email'}
                            labelColor='default'
                            id='email'
                            required={true}
                            type='text'
                            value={form.email}
                          >

                          </InputField>
                         </div>
                          <div>
                          <InputField
                            borderColor='default'
                            cb={this.inputChanged('password')}
                            disabled={false}
                            errors={this.state.errors?.password}
                            helperErrors={true}
                            label={'Password'}
                            labelColor='default'
                            id='password'
                            required={true}
                            type='password'
                            value={form.password}
                          >

                          </InputField>
                          </div>
                          <div className="flex items-center justify-between">
                              <div className="flex items-start">
                                  <div className="flex items-center h-5">
                                    <input id="remember" aria-describedby="remember" type="checkbox" className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800" />
                                  </div>
                                  <div className="ml-3 text-sm">
                                    <label className="text-gray-500">Remember me</label>
                                  </div>
                              </div>
                              <Link to="/forgot" className="text-sm font-medium text-primary-600 hover:underline">Forgot password?</Link>
                          </div>
                        <button type="button" onClick={this.verify} className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Sign in</button>
                          <p className="text-sm font-light text-gray-500">
                              Don’t have an account yet? <Link to="/signup" className="font-medium text-primary-600 hover:underline">Sign up</Link>
                          </p>
                      </form>
                  </div>
              </div>
          </div>
        </section>
        )
    }
}

export default Login